import * as React from "react";

import MUIDataTable, { FilterType, DisplayData, MUIDataTableOptions, MUIDataTableColumn } from "mui-datatables";

import { CustomToolbar } from "src/common/components/table/DiskTableCustomToolbar";
import { customBodyRender, customHeadLabelRender } from "src/common/components/table/tableCheckbox";
import { useRowStore, RowStore } from "src/common/hooks/rowSelection";

function buildColumns(
  rowStore: RowStore,
  resourceIdIndex: number,
  c: Array<MUIDataTableColumn>
): Array<MUIDataTableColumn> {
  let columns: MUIDataTableColumn[] = [
    {
      name: "checkbox",
      label: "Checkbox",
      options: {
        viewColumns: false,
        filter: false,
        sort: false,
        customHeadLabelRender: () => {
          return customHeadLabelRender(rowStore);
        },
        customBodyRender: (value, tableMeta) => {
          return customBodyRender(tableMeta, resourceIdIndex, rowStore);
        },
        customFilterListOptions: {
          render: (v) => {
            if (v) {
              return "Enabled";
            }

            return "Disabled";
          },
        },
      },
    },
  ];
  columns = columns.concat(c);
  return columns;
}

interface DiskTableProps {
  disks: Array<{
    id: string;
    diskStatus: string;
  }>;
  resourceIdIndex: number;
  noMatchState: React.ReactNode;
  columns: Array<MUIDataTableColumn>;
  deleteDisk: (ids: Array<string>) => Promise<any>;
}

export const DiskTable = ({ disks, resourceIdIndex, noMatchState, columns, deleteDisk }: DiskTableProps) => {
  const [numOfRowsPerPage, setNumOfRowsPerPage] = React.useState<number>(10);
  const [pageNum, setPageNum] = React.useState<number>(0);

  const rowStore = useRowStore(disks, numOfRowsPerPage, pageNum);

  resourceIdIndex = resourceIdIndex + 1; // Increment index to take into account the checkbox column

  const options: MUIDataTableOptions = {
    print: false,
    download: false,
    textLabels: {
      body: {
        noMatch: noMatchState,
      },
    },
    filterType: "multiselect" as FilterType,
    rowsPerPageOptions: [5, 10, 25, 50, 100],
    onChangeRowsPerPage: (numOfRows: number) => {
      setNumOfRowsPerPage(numOfRows);
    },
    onChangePage: (currentPage: number) => {
      setPageNum(currentPage);
    },
    customToolbar: ({ displayData }: { displayData: DisplayData }) => {
      rowStore.syncTable(displayData, resourceIdIndex);

      return <CustomToolbar rowStore={rowStore} diskTableData={disks} deleteDisk={deleteDisk} />;
    },
    selectableRows: "none", // Using our own custom row selection solution (built for per page selection)
  };

  return (
    <MUIDataTable
      title={rowStore.get().size > 0 ? <>Selected {rowStore.get().size} rows</> : <></>}
      data={disks}
      columns={buildColumns(rowStore, resourceIdIndex, columns)}
      options={options}
    />
  );
};
